import React from 'react'

function RadioCheckedIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" stroke="currentColor" />
      <rect x="3.85718" y="3.85718" width="10.2857" height="10.2857" rx="5.14286" fill="currentColor" />
    </svg>
  )
}


export default RadioCheckedIcon